import React from "react";
import Drawer from "@material-ui/core/Drawer";
import IconButton from "@material-ui/core/IconButton";
import Divider from "@material-ui/core/Divider";
import Button from "@material-ui/core/Button";
import { useSelector, useDispatch } from "react-redux";
import CloseIcon from "@material-ui/icons/Close";
import EditTicketTypeForm from "./EditTicketTypeForm";
import { SvgIconEdit } from "../../../components/NeIcons";
import ConfirmDialog from "../../../components/ConfirmDialog";
import { fetchTicketTypesById } from "../actions";
import { createStructuredSelector } from "reselect";
import { selectCustomerSupport } from "../selectors";

const stateSelector = createStructuredSelector({
  customerSupport: selectCustomerSupport,
});

export default function EditDialog({ id, classes, title }: any) {
  const { customerSupport }: any = useSelector(stateSelector);
  const ticketTypeDetail = customerSupport.customerSupportDetailInfo;

  const dispatch = useDispatch();
  const [isCloseAlertOpen, showAlertToClose] = React.useState(false);
  const [state, setState] = React.useState({
    right: false,
    isLoading: true,
  });

  const toggleDrawer = (anchor: string, open: boolean) => (event: any) => {
    if (id && !ticketTypeDetail) {
      dispatch(fetchTicketTypesById(id));
    }
    setState({ ...state, [anchor]: open, isLoading: open });
  };

  const closeDrawer = (anchor = "right", open = false) => {
    setState({ ...state, [anchor]: open, isLoading: open });
  };

  return (
    <React.Fragment>
      <IconButton
        onClick={toggleDrawer("right", true)}
        className={classes.editIcon}
        id={id}
      >
        <SvgIconEdit />
      </IconButton>

      <Drawer
        anchor="right"
        open={state.right}
        onClose={() => showAlertToClose(true)}
      >
        <ConfirmDialog
          isOpen={isCloseAlertOpen}
          headerText="Are you sure?"
          bodyText={`You are about to close this form.`}
          onAgree={() => closeDrawer("right", false)}
          handleClose={() => showAlertToClose(false)}
          onDisagree={() => showAlertToClose(false)}
        ></ConfirmDialog>

        <div className={classes.rightContainer}>
          <div className={classes.titleDiv}>
            <div className={classes.title}>{title}</div>
            <Button
              onClick={() => showAlertToClose(true)}
              className={classes.closeBtn}
            >
              <CloseIcon />
            </Button>
          </div>

          <Divider className={classes.divider} />
          {
            <>
              <EditTicketTypeForm
                formDetail={ticketTypeDetail}
                classes={classes}
                toggleFn={() => closeDrawer("right", false)}
                id={id}
              />
            </>
          }
        </div>
      </Drawer>
    </React.Fragment>
  );
}
